import axios from '../../axios';

export default async function getProfessionsRequest(): Promise<string[]> {
  const response = await axios.get<string[]>(
    `${process.env.REACT_APP_BASE_URL}/users/profession`
  );
  return response.data;
}
